export default {"src":"/uk/_next/static/media/connectIcon.70a05b77.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};